export default __webpack_public_path__ + "static/media/OnePage(Wider).cc3e7ff2.png";